/*
 * Action types, for strong typing.
 */
export const SET_TOKEN = 'SET_TOKEN';
export const CLEAR_TOKEN = 'CLEAR_TOKEN';

/*
 * Helper-functions for creating actions.
 */
export function setToken(token, user) {
  return { type: SET_TOKEN, token: token, user: user };
}
export function clearToken(token) {
  return { type: CLEAR_TOKEN };
}



// WEBPACK FOOTER //
// ./src/actions/token.js